





















































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component({})
export default class NewEditable extends Vue {
  @Prop({ required:true }) item!:any | null;
  @Prop({ default:"12" }) md!:string;
  @Prop({ default:"" }) label!:string;
  @Prop({ default:"text" }) type!:string;
  @Prop({ required:true }) propName!:string;
  @Prop({ required:true }) action!:string;
  @Prop({default: "12"}) sm: any;
  @Prop({default: () => []}) rules!: any[];
  @Prop({ default: null }) maxlength!: string | number | null;

  @Watch('item')
  onPropertyChanged(value: any, oldValue: any) {
    this.value = value[this.propName];
    this.editValue = this.value;
  }

  value: string = "";
  editValue: string = "";
  prevValue: string = "";
  spinner: boolean = false;
  isEditing: boolean = false;
  hasError: boolean = false;
  errorMessage: string = "";

  get displayValue() {
    if (this.type === 'textarea') {
      return this.value ? `"${this.value}"` : 'Değer giriniz...';
    }
    return this.value || 'Değer giriniz...';
  }

  created() {
    this.value = this.item[this.propName] || "";
    this.editValue = this.value;
    this.prevValue = this.value;
  }

  handleInput(value: string) {
    if (this.propName === 'tc_no') {
      this.$nextTick(() => {
        this.editValue = value.replace(/[^0-9]/g, '');
      });
    }
  }

  startEdit() {
    if (this.spinner) return;

    this.isEditing = true;
    this.editValue = this.value;
    this.prevValue = this.value;

    this.$nextTick(() => {
      (this.$refs.editField as any)?.$el?.querySelector('input, textarea')?.focus();
    });
  }

  async save() {
    if (this.prevValue === this.editValue) {
      this.cancel();
      return;
    }

    // TC Kimlik No validasyonu
    if (this.propName === 'tc_no') {
      const tcValidationResult = this.validateTc(this.editValue);
      if (tcValidationResult !== true) {
        this.hasError = true;
        this.errorMessage = tcValidationResult;
        return;
      }
    }

    // Email validasyonu
    if (this.propName === 'email' || this.type === 'email') {
      if (!this.validateEmail(this.editValue)) {
        this.hasError = true;
        this.errorMessage = "Geçerli bir e-posta adresi giriniz";
        return;
      }
    }

    // Hata durumunu temizle
    this.hasError = false;
    this.errorMessage = "";

    this.spinner = true;

    try {
      // Müşteri numarası parent component'ten gelecek
      const musteriNo = this.item.musteri_no || this.item.id;

      const requestPayload: any = {
        musteri_no: musteriNo
      };
      requestPayload[this.propName] = this.editValue;

      if (this.action.includes('updateRumuz')) {
        const tcNo = this.item.tc_no || this.item.tcNo;

        if (tcNo) {
          requestPayload.tc_no = tcNo;
        }
      }

      // Eğer gönderilen alan tc_no ise item içindeki değeri de güncelle
      if (this.propName === 'tc_no') {
        this.item.tc_no = this.editValue;
      }

      const response = await Vue.prototype.$http.post(this.action, {
        data: requestPayload,
        sendJson: true
      });

      if (typeof response.data !== "object" || response.status !== 200) {
        this.editValue = this.prevValue;
        this.hasError = true;
        this.errorMessage = 'Lütfen geçerli bir değer giriniz.';
        this.$emit('error', 'Lütfen geçerli bir değer giriniz.');
        return;
      }

      this.value = this.editValue;
      this.prevValue = this.editValue;
      this.item[this.propName] = this.editValue; // güncel değeri item içinde de tut
      this.$emit("success", true);

    } catch (error) {
      this.editValue = this.prevValue;
      this.hasError = true;
      this.errorMessage = 'Güncelleme sırasında bir hata oluştu';
      console.error('Güncelleme hatası:', error);
    } finally {
      this.spinner = false;
      this.isEditing = false;
    }
  }

  cancel() {
    this.editValue = this.prevValue;
    this.hasError = false;
    this.errorMessage = "";
    this.isEditing = false;
  }

  onBlur() {
    // Küçük bir delay ile blur eventi kontrol et
    // Bu, kullanıcının kaydet/iptal butonlarına tıklama şansı vermek için
    setTimeout(() => {
      if (this.isEditing) {
        this.cancel();
      }
    }, 150);
  }

  serialize(obj: any) {
    const str: string[] = [];
    for (const p in obj) {
      if (obj.hasOwnProperty(p)) {
        const value = obj[p];
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(value != null ? String(value) : ''));
      }
    }
    return str.join("&");
  }

  // Email validasyon fonksiyonu
  validateEmail(email: string): boolean {
    if (!email) return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // Email geçerlilik kontrolü (daha kapsamlı)
  isValidEmail(email: string): boolean {
    if (!email || email.trim() === '') return false;

    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(email);
  }

  validateTc(tc: string): true | string {
    if (!tc || tc.trim() === '') return 'TC Kimlik No zorunludur.';

    const tcStr = String(tc);

    if (!/^\d{11}$/.test(tcStr)) {
      return "TC Kimlik No 11 rakamdan oluşmalıdır.";
    }

    const digits = tcStr.split('').map(Number);

    if (digits[0] === 0) {
      return "TC Kimlik No'nun ilk hanesi 0 olamaz.";
    }

    const oddSum = digits[0] + digits[2] + digits[4] + digits[6] + digits[8];
    const evenSum = digits[1] + digits[3] + digits[5] + digits[7];

    let tenthDigit = (oddSum * 7 - evenSum) % 10;
    if (tenthDigit < 0) {
      tenthDigit += 10;
    }

    if (digits[9] !== tenthDigit) {
      return "Geçersiz TC Kimlik No.";
    }

    const totalSum = digits.slice(0, 10).reduce((acc, digit) => acc + digit, 0);
    const eleventhDigit = totalSum % 10;

    if (digits[10] !== eleventhDigit) {
      return "Geçersiz TC Kimlik No.";
    }

    return true;
  }
}
